import type { EntityAdapter } from "@/components/tables/entityAdapters/entityAdapter";

type SubjectExaminationDeadlineCreatePayload = {
  examination_set: string[];
  valid_until?: string;
  executed_on?: string;
  faux_overdue?: boolean;
  subject_set?: string[];
  company_subject?: string | number;
  department_set?: string[];
};

const EDITABLE_STATUSES = ["valid", "overdue"];

export const subjectExaminationDeadlineEntityAdapter: EntityAdapter = {
  entity: "subjectExaminationDeadline",
  finishCreatePayload: (_result, values, ctx) => {
    let payload: SubjectExaminationDeadlineCreatePayload = {
      examination_set: values.examination_set,
    };
    if (values.faux_overdue === true) {
      payload = { ...payload, faux_overdue: true };
    } else {
      payload = {
        ...payload,
        valid_until: values.valid_until,
        executed_on: values.executed_on,
      };
    }
    if (values.department_set && values.department_set.length !== 0) {
      payload = { ...payload, department_set: values.department_set };
    }
    if (values.create_sed_for_company === true) {
      payload = { ...payload, company_subject: ctx.globalSubjectValue };
    }
    if (values.subject_set && values.subject_set.length !== 0) {
      payload = {
        ...payload,
        subject_set: values.subject_set.map((option: any) => option.value),
      };
    }
    return payload;
  },
  defaultSort: {
    sort: "subject_set",
    tableSort: "subject_set",
    descending: false,
  },
  searchPlaceholder: (t) => `${t("examination")}...`,
  isRowActionAllowed: (deadline, { subdomain }) =>
    EDITABLE_STATUSES.includes(deadline.status) &&
    (subdomain !== "manage" || Boolean(deadline.can_be_managed_by_manager)),
  toolbar: {
    showsActionButtonInReadOnlyMode: (subdomain) => subdomain === "manage",
  },
  autoCalculatesValidUntil: true,
};
